import { render } from "./CompanyData.vue?vue&type=template&id=50b09080&scoped=true"
import script from "./CompanyData.vue?vue&type=script&lang=js"
export * from "./CompanyData.vue?vue&type=script&lang=js"

import "./CompanyData.vue?vue&type=style&index=0&id=50b09080&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b09080"]])

export default __exports__